import { Component, OnInit } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, TranslateModule]
})
export class LoaderComponent implements OnInit {

  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  constructor() { }

  ngOnInit(): void { }

}
